import tableShow from './reducers'

export { showTable, hideTable } from './actions'

export default tableShow
